// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__22a5z","info":"PatientInfo_info__3L1nA"};